module.exports = __webpack_public_path__ + "static/images/9b07d32f.svg";